/* eslint-disable camelcase */
// eslint-disable-next-line import/prefer-default-export
export const UniswapV2Router02 = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D'
export const DollarPool1 = '0x87033b47CA6AFa615Af89281240BB32DF5de3dEA'
export const DollarPool2 = '0x87033b47CA6AFa615Af89281240BB32DF5de3dEA'
export const DollarPool3 = '0x87033b47CA6AFa615Af89281240BB32DF5de3dEA'
export const DollarPool4 = '0x87033b47CA6AFa615Af89281240BB32DF5de3dEA'
